import { requester } from '../utils';

export const autoGenerateReserveTimes = data => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: 'v1/cafe-time-slice/auto-generate',
        method: 'POST',
        data,
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};
